import axiosInstance from '../Utility/axiosconfigpay'
import axiosInstance1 from '../Utility/axiosconfig'

const listpayment = async (data, inv) => {
    try {
        const res = await axiosInstance.post('api/charge/create', {
            account_id: process.env.REACT_APP_AUCTIONPAYKEY,
            customer: data.customer,
            description: 'TEST TRANSACTION',
            amount: data.amount,
            currency: 'usd',
            source: data.source,
        })

        if (res.data.status === 'success') {
            console.log('test')
            const response = await axiosInstance1.post('mobileapi/successGroupInvoice', {
                buyerPremiumTotal: 1,
                inv,
                mode: 'sandbox',
                trans_gateway: 'Card Payment',
                shipAmt: '0.00',
                shipCmb: '0.00',
                shipOrg: '0.00',
                payamt: parseInt(res.data.data.responseData.amount),
                totalInvoice: parseInt(res.data.data.responseData.amount),
                transaction_id: res.data.data.responseData.id,
            })
            if (response.data.success === 'yes') {
                return true
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export default listpayment
